'use client'

import {Settings, Timer, UserPlus} from 'lucide-react'
import type {SettingsState} from '@/types'
import {PageHeader} from '@/components/PageHeader'
import {Switch} from '@/components/Switch'

export function AutomationView({
    settings,
    saveSettings,
}: {
    settings: SettingsState
    saveSettings: (patch: Partial<SettingsState>) => void
}) {
    const security = settings.security

    return (
        <section className="flex flex-col h-full bg-page">
            <PageHeader title="自动化与安全机制" description="保护账号安全，避免触发风控"/>
            <div className="flex-1 overflow-y-auto p-6">
                <div className="w-full max-w-4xl mr-auto">
                    <div className="bg-white rounded-card shadow-card border border-hair p-8">
                        <div className="mb-8 flex items-center gap-3">
                            <Settings size={24} className="text-accent"/>
                            <h3 className="text-base font-medium text-ink">基础安全策略</h3>
                        </div>
                        <div className="space-y-8">
                            <div className="flex items-center justify-between border-b border-hair pb-6 gap-4">
                                <div className="pr-10 min-w-0">
                                    <div className="text-ink font-medium mb-2 text-base flex items-center gap-2">
                                        <UserPlus size={18} className="text-muted"/>
                                        自动通过好友申请
                                    </div>
                                    <div className="text-sm text-muted leading-relaxed">
                                        开启后，机器人将自动同意好友申请。
                                    </div>
                                </div>
                                <Switch
                                    checked={security.autoAcceptFriend}
                                    onChange={() =>
                                        saveSettings({
                                            security: {
                                                ...security,
                                                autoAcceptFriend: !security.autoAcceptFriend,
                                            },
                                        })
                                    }
                                />
                            </div>
                            <div className="flex items-center justify-between gap-4">
                                <div className="pr-10 min-w-0">
                                    <div className="text-ink font-medium mb-2 text-base flex items-center gap-2">
                                        <Timer size={18} className="text-muted"/>
                                        消息回复延迟时间
                                    </div>
                                    <div className="text-sm text-muted leading-relaxed">
                                        模拟真人打字延迟，减少频繁自动回复风险。
                                    </div>
                                </div>
                                <div className="flex items-center gap-2 bg-gray-50 p-2 rounded border border-hair shrink-0">
                                    <input
                                        type="number"
                                        min={0}
                                        value={security.replyDelaySeconds}
                                        onChange={(event) =>
                                            saveSettings({
                                                security: {
                                                    ...security,
                                                    replyDelaySeconds: Number(event.target.value),
                                                },
                                            })
                                        }
                                        className="w-16 border border-hair rounded p-1.5 text-center text-sm focus:outline-none focus:border-accent"
                                    />
                                    <span className="text-sm text-soft px-2">秒</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
